import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import OpcModelEditDto from '../dto/OpcModelEditDto';
import ModelEditTransform from 'app/admin/model/util/ModelEditTransform';


class OpcModelEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'opcModelEditControl';
		this.KEEP_NULL_MAP_KEYS = true;
	}

	_transformDtoForSaveOrUpdate(dto) { return ModelEditTransform.transformDtoForSaveOrUpdate(dto, { keepNullMapKeys: this.KEEP_NULL_MAP_KEYS }); }

	_transformDtoFromLoad(dto) { return ModelEditTransform.transformDtoFromLoad(dto, { keepNullMapKeys: this.KEEP_NULL_MAP_KEYS }); }

	/**
	 * @param {string} driverName
	 * @return {Promise<OpcModelEditDto>}
	 */
	create(driverName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/create`, { driverName })
				.then(response => resolve(new OpcModelEditDto().setup(this._transformDtoFromLoad(response.data))))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<OpcModelEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new OpcModelEditDto().setup(this._transformDtoFromLoad(response.data))))
				.catch(reject);
		});
	}

	/**
	 * @param {OpcModelEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto: this._transformDtoForSaveOrUpdate(dto)
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {OpcModelEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto: this._transformDtoForSaveOrUpdate(dto)
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new OpcModelEditService();
